import Http from "../util/Http";

class MembershipApi {
    static async getActiveWriteMembership() {
        const res = await Http.get("/membership/write/active");
        return res?.membership || null;
    }
}

export default MembershipApi;
